export const iconFontAwesomeLogisticsTrainSubway = (
	<i className="fa-solid fa-train-subway"></i>
);
